import { render, staticRenderFns } from "./issuePopup.vue?vue&type=template&id=c0d888e0&scoped=true"
import script from "./issuePopup.vue?vue&type=script&lang=js"
export * from "./issuePopup.vue?vue&type=script&lang=js"
import style0 from "./issuePopup.vue?vue&type=style&index=0&id=c0d888e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d888e0",
  null
  
)

export default component.exports